import { CHARGEBACKS, CHARGEBACKS_PAGINATE, GET_CHARGEBACKS,
  IMPORT_CHARGEBACKS, NOTIFICATIONS_INCLUDE, UPDATE_CHARGEBACK } from '@store/types'
import axios from 'axios'
import shortly from 'vuex-shortly'

const state = {
  chargebacks: [],
  paginate: {}
}

const getters = {
  [CHARGEBACKS]: 'chargebacks',
  [CHARGEBACKS_PAGINATE]: 'paginate'
}

const mutations = {
  [CHARGEBACKS]: 'chargebacks',
  [CHARGEBACKS_PAGINATE]: 'paginate'
}

const actions = {
  [GET_CHARGEBACKS]: async ({ commit, dispatch }, filters) => {
    const filtersKeys = Object.keys(filters)
    const error = new Error('Não foi possível obter os chargebacks, tente novamente mais tarde!')
    let errorMessage = false
    let stringFilters = ''
    filtersKeys.forEach(key => {
      if (filters[`${key}`] !== null && filters[key] !== undefined && filters[key] !== '') {
        stringFilters += `${key}=${filters[key]}&`
      }
    })

    const response = await axios.get(`chargeback?${stringFilters}`).catch(e => {
      dispatch(NOTIFICATIONS_INCLUDE, error)
      errorMessage = true
      return Promise.reject(error)
    })

    if (response.data && response.data.data) {
      commit(CHARGEBACKS, response.data.data)
      const paginate = { ...response.data, per_page: filters.limit }
      delete paginate.data
      commit(CHARGEBACKS_PAGINATE, paginate)
      return response.data.data
    } else {
      if (!errorMessage) {
        return Promise.reject(new Error(error))
      }
    }
  },
  [UPDATE_CHARGEBACK]: async ({ dispatch }, payload) => {
    const error = new Error('Não foi possível alterar seu chargeback, por favor, tente novamente mais tarde!')
    let errorMessage = false
    const response = await axios.put(`chargeback/${payload.id}`, payload).catch(e => {
      dispatch(NOTIFICATIONS_INCLUDE, error)
      errorMessage = true
    })

    if (response.data && response.data.success) {
      dispatch(NOTIFICATIONS_INCLUDE,
        {
          type: 'success',
          message: 'Chargeback alterado com sucesso!'
        })
    } else {
      if (!errorMessage) {
        dispatch(NOTIFICATIONS_INCLUDE, error)
      }
    }
  },
  [IMPORT_CHARGEBACKS]: async ({ dispatch }, payload) => {
    const { file } = payload
    const data = new FormData()
    data.append('file', file)
    const error = 'Não foi possível importar o seu arquivo. Tente novamente mais tarde!'
    let errorMessage = false
    const response = await axios.post('chargeback/upload', data).catch(e => {
      dispatch(NOTIFICATIONS_INCLUDE, new Error(error))
      errorMessage = true
    })

    if (response && response.data && response.data.success) {
      dispatch(NOTIFICATIONS_INCLUDE,
        {
          type: 'success',
          message: 'Upload feito com sucesso!'
        })
      return response.data
    } else {
      if (!errorMessage) {
        dispatch(NOTIFICATIONS_INCLUDE, new Error(error))
      }
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/chargebacks.js